/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DurationLikeObject
 */
export interface DurationLikeObject {
    /**
     * 
     * @type {number}
     * @memberof DurationLikeObject
     */
    years?: number;
    /**
     * 
     * @type {number}
     * @memberof DurationLikeObject
     */
    quarters?: number;
    /**
     * 
     * @type {number}
     * @memberof DurationLikeObject
     */
    months?: number;
    /**
     * 
     * @type {number}
     * @memberof DurationLikeObject
     */
    weeks?: number;
    /**
     * 
     * @type {number}
     * @memberof DurationLikeObject
     */
    days?: number;
    /**
     * 
     * @type {number}
     * @memberof DurationLikeObject
     */
    hours?: number;
    /**
     * 
     * @type {number}
     * @memberof DurationLikeObject
     */
    minutes?: number;
    /**
     * 
     * @type {number}
     * @memberof DurationLikeObject
     */
    seconds?: number;
    /**
     * 
     * @type {number}
     * @memberof DurationLikeObject
     */
    milliseconds?: number;
    /**
     * 
     * @type {number}
     * @memberof DurationLikeObject
     */
    year?: number;
    /**
     * 
     * @type {number}
     * @memberof DurationLikeObject
     */
    quarter?: number;
    /**
     * 
     * @type {number}
     * @memberof DurationLikeObject
     */
    month?: number;
    /**
     * 
     * @type {number}
     * @memberof DurationLikeObject
     */
    week?: number;
    /**
     * 
     * @type {number}
     * @memberof DurationLikeObject
     */
    day?: number;
    /**
     * 
     * @type {number}
     * @memberof DurationLikeObject
     */
    hour?: number;
    /**
     * 
     * @type {number}
     * @memberof DurationLikeObject
     */
    minute?: number;
    /**
     * 
     * @type {number}
     * @memberof DurationLikeObject
     */
    second?: number;
    /**
     * 
     * @type {number}
     * @memberof DurationLikeObject
     */
    millisecond?: number;
}

/**
 * Check if a given object implements the DurationLikeObject interface.
 */
export function instanceOfDurationLikeObject(value: object): value is DurationLikeObject {
    return true;
}

export function DurationLikeObjectFromJSON(json: any): DurationLikeObject {
    return DurationLikeObjectFromJSONTyped(json, false);
}

export function DurationLikeObjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): DurationLikeObject {
    if (json == null) {
        return json;
    }
    return {
        
        'years': json['years'] == null ? undefined : json['years'],
        'quarters': json['quarters'] == null ? undefined : json['quarters'],
        'months': json['months'] == null ? undefined : json['months'],
        'weeks': json['weeks'] == null ? undefined : json['weeks'],
        'days': json['days'] == null ? undefined : json['days'],
        'hours': json['hours'] == null ? undefined : json['hours'],
        'minutes': json['minutes'] == null ? undefined : json['minutes'],
        'seconds': json['seconds'] == null ? undefined : json['seconds'],
        'milliseconds': json['milliseconds'] == null ? undefined : json['milliseconds'],
        'year': json['year'] == null ? undefined : json['year'],
        'quarter': json['quarter'] == null ? undefined : json['quarter'],
        'month': json['month'] == null ? undefined : json['month'],
        'week': json['week'] == null ? undefined : json['week'],
        'day': json['day'] == null ? undefined : json['day'],
        'hour': json['hour'] == null ? undefined : json['hour'],
        'minute': json['minute'] == null ? undefined : json['minute'],
        'second': json['second'] == null ? undefined : json['second'],
        'millisecond': json['millisecond'] == null ? undefined : json['millisecond'],
    };
}

export function DurationLikeObjectToJSON(value?: DurationLikeObject | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'years': value['years'],
        'quarters': value['quarters'],
        'months': value['months'],
        'weeks': value['weeks'],
        'days': value['days'],
        'hours': value['hours'],
        'minutes': value['minutes'],
        'seconds': value['seconds'],
        'milliseconds': value['milliseconds'],
        'year': value['year'],
        'quarter': value['quarter'],
        'month': value['month'],
        'week': value['week'],
        'day': value['day'],
        'hour': value['hour'],
        'minute': value['minute'],
        'second': value['second'],
        'millisecond': value['millisecond'],
    };
}

